import { createSelector } from 'reselect';
import { Parser } from 'hot-formula-parser';
import _ from 'lodash';
import { Unflatten } from 'utils/commonFunc';

const attributesPointer = state => state.tenderCard.attributes;
const pricePointer = state => state.tenderCard.info.price;

export default createSelector([attributesPointer, pricePointer], (attributes, price) => {
  const activeAttributes = attributes.filter(el => el.isActive);
  const newAttr = _.cloneDeep(activeAttributes);
  const newAttributes = newAttr.map(item => {
    if (item.typeId === 8) {
      const parser = new Parser();
      if (item.value && item.value.vars && item.value.vars.length > 0) {
        item.value.vars.forEach(el => {
          let value;
          if (el.value === -1) {
            value = price;
          } else {
            const attribute = attributes.find(attr => attr.id === +el.value);
            if (attribute && !attribute.isActive) {
              item.error = true;
              item.result = 'Расчет невозможен';
              item.message = 'Одна или несколько переменных - архивные параметры тендера';
              return;
            }
            if (attribute && attribute.typeId === 2 && attribute.isActive) {
              ({ value } = attribute);
            }
          }
          parser.setVariable(`${el.name[0]}_${el.name.substr(1)}`, value || 0);
        });
      }
      if (item.result) {
        return item;
      }
      if (item.value && item.value.equation) {
        const equation = item.value.equation
          .replace(/(x\d+)/gi, match => `${match[0]}_${match.substr(1)}`)
          .replace(',', '.');
        const equationResult = parser.parse(equation);
        if (!equationResult.error) {
          const result = +equationResult.result.toFixed(2);
          item.result = `${result.toString().replace('.', ',')}  ${item.value.unit || ''}`;
        } else {
          item.error = true;
          item.result = 'Ошибка в формуле или расчете';
          item.message = 'Обратитесь к администратору';
        }
      } else {
        item.error = true;
        item.result = 'Отсутствует формула для расчёта';
        item.message = 'Обратитесь к администратору';
      }
    }

    if (item.typeId === 3) {
      item.options = Unflatten(item.options || []);
    }

    return item;
  });
  const initialValues = {
    field: null,
    attributes: Unflatten(newAttributes),
  };
  return {
    tenderPrice: price,
    initialValues,
  };
});
